import React from 'react';
import { graphql, compose } from 'react-apollo';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import CheckIco from 'react-icons/lib/md/check';
import AvailableIco from 'react-icons/lib/md/flag';

// Query
import fetchUserSurveys from '../../../queries/fetchUserSurveys';
import fetchSurveys from '../../../queries/fetchAllSurveys';

const parameterization = (parameterization, userDetails) => {
	const {
		genero: pGenero,
		nivel_educativo: pNivel,
		estrato: pEstrato,
		departamento: pDepartamento,
		profileType: pProfileType
	} = parameterization;
	const {
		genero: uGenero,
		nivel_educativo: uNivel,
		estrato: uEstrato,
		departamento: uDepartamento,
		tipoPerfil: uProfileType
	} = userDetails;

	if (_.isNumber(pGenero) && pGenero !== Number(uGenero)) {
		return false;
	} else if (pProfileType !== 0 && Number(pProfileType) !== Number(uProfileType)) {
		return false;
	} else if (_.isNumber(pNivel) && pNivel < Number(uNivel)) {
		return false;
	} else if (_.isNumber(pEstrato) && pEstrato > Number(uEstrato)) {
		return false;
	} else if (
		_.isNumber(pDepartamento) &&
		pDepartamento !== Number(uDepartamento)
	) {
		return false;
	}
	return true;
};

const renderSurveys = (surveys, user) => {
	const {
    surveys: userSurveys,
    person: userDetails,
    tipoPerfil
} = user;
	const userSurveysList = _.map(userSurveys, i => i.surveyId);
	return _.map(surveys, survey => {
		if (!survey.published) {
			return null;
		}
		if (survey.parameterization.active) {
			const passed = parameterization(survey.parameterization, {
				...userDetails,
				tipoPerfil
			});
			if (!passed) {
				return null;
			}
		}
		if (_.includes(userSurveysList, survey.id)) {
			return (
				<tr key={survey.id}>
					<th scope="row">
						<a className="disabled">{survey.titulo}</a>
					</th>
					<td>{survey.descripcion}</td>
					<td>
						<span className="text-success">
							<CheckIco /> Completado
						</span>
					</td>
				</tr>
			);
		}
		return (
			<tr key={survey.id}>
				<th scope="row">
					<Link to={`/dashboard/encuesta/${survey.id}`}>{survey.titulo}</Link>
				</th>
				<td>{survey.descripcion}</td>
				<td>
					<Link to={`/dashboard/encuesta/${survey.id}`}>
						<AvailableIco /> Disponible
					</Link>
				</td>
			</tr>
		);
	});
};

const SurveyList = props => {
	if (props.fetchSurveys.loading && props.fetchUserSurveys.loading) {
		return <div className="loader">Loading...</div>;
	}
	if (props.fetchSurveys.surveys && props.fetchUserSurveys.user) {
		return (
			<div className="container">
				<h1>Listado de Encuestas</h1>
				<table className="table table-striped">
					<thead>
						<tr>
							<th scope="col">Título</th>
							<th scope="col">Descripción</th>
							<th scope="col">Estado</th>
						</tr>
					</thead>
					<tbody>
						{renderSurveys(
							props.fetchSurveys.surveys,
							props.fetchUserSurveys.user
						)}
					</tbody>
				</table>
			</div>
		);
	}
	return null;
};

export default compose(
	graphql(fetchUserSurveys, {
		name: 'fetchUserSurveys'
	}),
	graphql(fetchSurveys, {
		name: 'fetchSurveys'
	})
)(SurveyList);



// WEBPACK FOOTER //
// ./src/components/Survey/consumer/SurveyList.js